import { LandingRoute } from '@app/src/app/modules/landing';

/**
 * White list of top level navigation routes, all children will be allowed
 */
export const LINKS_WHITELIST: string[] = [
  `/${LandingRoute.ROOT}/`, // landing (sign up) non authed,
];
